export default "__VITE_ASSET__CTfWDCTS__"